module.exports = __webpack_public_path__ + "img/bgparallax-01.320111c8.jpg";